/** Rutas de la web (SDD §7.2). */
import { createBrowserRouter, Link, RouterProvider } from 'react-router'
import { AppProvider, ToastProvider } from './components/AppContext'
import { Layout, RequireAuth } from './components/Layout'
import { AdminLayout } from './views/admin/AdminLayout'
import { Ajustes } from './views/admin/Ajustes'
import { Auditoria } from './views/admin/Auditoria'
import { Costos } from './views/admin/Costos'
import { Equipos } from './views/admin/Equipos'
import { Ficha } from './views/admin/Ficha'
import { Operacion } from './views/admin/Operacion'
import { Promociones } from './views/admin/Promociones'
import { Resumen } from './views/admin/Resumen'
import { Usuarios } from './views/admin/Usuarios'
import { Detail } from './views/Detail'
import { Help } from './views/Help'
import { Import } from './views/Import'
import { Tasks } from './views/Tasks'
import { Team } from './views/Team'
import { AcceptInvite } from './views/AcceptInvite'
import { Library } from './views/Library'
import { Login } from './views/Login'
import { Plan } from './views/Plan'
import { PublicShare } from './views/PublicShare'
import { Security } from './views/Security'
import { Settings } from './views/Settings'
import { Welcome } from './views/Welcome'

function NotFound() {
  return (
    <div className="page narrow">
      <div className="empty">
        <h2>Esta página no existe</h2>
        <Link to="/" className="btn" style={{ marginTop: 12 }}>
          Ir al inicio
        </Link>
      </div>
    </div>
  )
}

/**
 * Si una vista se cae, esto reemplaza la pantalla de error en inglés del router. En el
 * panel queda dentro del menú de la app (el error lo atrapa la ruta /admin).
 */
function FalloVista() {
  return (
    <div className="page narrow">
      <div className="empty" role="alert">
        <h2>Algo falló al mostrar esta página</h2>
        <p className="faint">Recarga la página. Si vuelve a pasar, escríbenos a hola@holaeco.cl.</p>
        <button
          type="button"
          className="btn"
          style={{ marginTop: 12 }}
          onClick={() => location.reload()}
        >
          Recargar
        </button>
      </div>
    </div>
  )
}

export const routes = [
  { path: '/login', element: <Login /> },
  { path: '/bienvenida', element: <Welcome /> },
  { path: '/seguridad', element: <Security /> },
  { path: '/ayuda', element: <Help /> },
  { path: '/s/:token', element: <PublicShare /> },
  { path: '/invitacion/:token', element: <AcceptInvite /> },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <Layout />,
        errorElement: <FalloVista />,
        children: [
          { path: '/', element: <Library /> },
          { path: '/p/:id', element: <Library /> },
          { path: '/r/:id', element: <Detail /> },
          { path: '/import', element: <Import /> },
          { path: '/tareas', element: <Tasks /> },
          { path: '/plan', element: <Plan /> },
          { path: '/equipo', element: <Team /> },
          { path: '/settings', element: <Settings /> },
          {
            path: '/admin',
            element: <AdminLayout />,
            errorElement: <FalloVista />,
            children: [
              { index: true, element: <Resumen /> },
              { path: 'usuarios', element: <Usuarios /> },
              { path: 'usuarios/:id', element: <Ficha /> },
              { path: 'equipos', element: <Equipos /> },
              { path: 'operacion', element: <Operacion /> },
              { path: 'costos', element: <Costos /> },
              { path: 'promociones', element: <Promociones /> },
              { path: 'auditoria', element: <Auditoria /> },
              { path: 'ajustes', element: <Ajustes /> }
            ]
          },
          { path: '*', element: <NotFound /> }
        ]
      }
    ]
  }
]

const router = createBrowserRouter(routes)

export function App() {
  return (
    <AppProvider>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </AppProvider>
  )
}
